import { WP_URL } from '@shared/config/env'

export async function wpQuery<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
  const res = await fetch(`${WP_URL}/graphql`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  })

  if (!res.ok) throw new Error(`WP GraphQL HTTP ${res.status}`)

  const json = await res.json() as { data?: T; errors?: { message: string }[] }

  if (json.errors?.length) throw new Error(json.errors[0].message)
  if (!json.data) throw new Error('Empty GraphQL response')

  return json.data
}
